import ActivityNote from "./object/ActivityNote";
import ActivityQuestion from "./object/ActivityQuestion";
import { ActivityObject as ActivityObjectType } from "../../../@types/activities";
import ActivitySurvey from "./object/ActivitySurvey.tsx";
import ActivityAppointment from "@/components/activitystreams/activity/object/ActivityAppointment.tsx";
import ActivityArticle from "@/components/activitystreams/activity/object/ActivityArticle.tsx";

type ActivityObjectArgs = ActivityObjectType & {
  activityId: string;
  language?: string;
  translated?: boolean;
  showMoreButton?: boolean;
  isHit?: boolean;
  content?: string;
  readOnly?: boolean;
};

export default function ActivityObject(props: ActivityObjectArgs) {
  const { type, activityId } = props;

  function renderObjectType() {
    switch (type) {
      case "note":
        return <ActivityNote {...props} />;
      case "question":
        return <ActivityQuestion {...props} activityId={activityId} />;
      case "survey":
        return (
          <ActivitySurvey {...props} activityId={activityId} type={type} />
        );
      case "schedule":
        return (
          <ActivitySurvey
            {...props}
            activityId={activityId}
            type={type}
            isSchedule
          />
        );
      case "appointment":
        return <ActivityAppointment {...props} type={type} />;
      case "article":
        return <ActivityArticle {...props} type={type} />;
      default:
        return <div>TODO</div>;
    }
  }

  return renderObjectType();
}
